/* eslint complexity: "off", max-depth: "off" */
import moment from 'moment'
const trustworthy = {
  manual_transcript: true,
  extracted_document: true,
  tax_transcript: true,
  manual_document: true
}
export default (data, fiscalYears) => {
  if (!Array.isArray(data)) {
    throw new Error('Invalid data format. Data must be an array.')
  }
  const diffs = []
  const categories = []
  const years = []
  const validYears = fiscalYears.map(fy => fy.year)
  for (const datum of data) {
    if (categories.indexOf(datum.category) < 0) {
      categories.push(datum.category)
    }
    if (years.indexOf(datum.year) < 0 && validYears.includes(datum.year)) {
      years.push(datum.year)
    }
  }
  for (const category of categories) {
    for (const year of years) {
      const filteredByCategoryAndYear = data.filter(datum => datum.category === category && datum.year === year).sort((a, b) => b.createdAt - a.createdAt)
      if (filteredByCategoryAndYear.length > 1) {
        const { period } = fiscalYears.find(y => y.year === year)
        const [first] = filteredByCategoryAndYear
        const transcriptDatum = filteredByCategoryAndYear.find(datum => datum.source === 'tax_transcript')
        const documentDatum = filteredByCategoryAndYear.find(datum => datum.source === 'manual_document')
        const extractedDatum = filteredByCategoryAndYear.find(datum => datum.source === 'extracted_document')
        const manualDatum = filteredByCategoryAndYear.find(datum => datum.source === 'manual_transcript')
        const averageDatum = filteredByCategoryAndYear.find(datum => datum.source === 'derived' && period === 'interim')
        let diff = null
        if (!(first.source in trustworthy)) {
          if (transcriptDatum) {
            diff = first.data - transcriptDatum.data
          } else if (manualDatum) {
            diff = first.data - manualDatum.data
          } else if (extractedDatum) {
            diff = first.data - extractedDatum.data
          } else if (documentDatum) {
            diff = first.data - documentDatum.data
          } else if (averageDatum) {
            diff = first.data - averageDatum.data
          }
          if (diff > 0 || diff < 0 && diff !== null) {
            const { accountable, createdAt } = first
            diffs.push({ diff, category, discrepancy: false, year, accountable: accountable.name, lastEdited: moment.unix(createdAt).format('MM/DD/YYYY') })
          }
        }
      }
    }
  }
  return diffs
}
